import {Modal} from "antd";
import {BulbOutlined} from "@ant-design/icons";
import {Prompts} from "@ant-design/x";
import {useEffect, useState} from "react";
import {Spacer} from "../../../components/DesignSystem/Spacer/Spacer";


export const SuggestionsModal = ({suggestions, onSelect, onClose}) => {

    const [items, setItems] = useState([]);

    useEffect(() => {

        if (suggestions) {
            const newItems = suggestions.map((item, index) => ({
                key: index,
                icon: <BulbOutlined style={{color: '#FFD700'}}/>,
                label: item.Category,
                description: item.Question,
            }));
            setItems(newItems);
        }

    }, [suggestions]);


    return <Modal width={1000}
                  title="Suggested Prompts"
                  centered
                  open={true}
                  onCancel={onClose}
                  onOk={onClose}
    >
        <Spacer size={"large"}/>
        <Prompts
            items={items}
            onItemClick={info => {
                onSelect(info.data.description);
            }}
            wrap
            styles={{
                item: {
                    flex: 'none',
                    width: 'calc(50% - 6px)',
                },
            }}
        />
    </Modal>

}